module.exports = __webpack_public_path__ + "img/book-btn04.fcafa621.png";